import { Button, SimpleGrid, Text } from "@govlaunch/web";
import React from "react";
import { FacebookIcon, FacebookShareButton, TwitterIcon, TwitterShareButton } from "react-share";
import { IProductFieldsFragment } from "../fragments/__generated__/ProductFieldsFragment.generated";
import { FormattedMessage, useIntl } from "react-intl";

interface IProductSharingProps {
  product: IProductFieldsFragment;
  onToggleBookmark?: (product: IProductFieldsFragment) => void;
}

export default function ProductSharing({ product, onToggleBookmark }: IProductSharingProps) {
  const intl = useIntl();

  return (
    <SimpleGrid gridAutoFlow="column" gridColumnGap={4}>
      <FacebookShareButton url={getCurrentUrl() || `/products/${product.slug}`}>
        <SimpleGrid alignItems="center" gridAutoFlow="column" gridColumnGap={2} p={1}>
          <Text fontSize="sm" fontWeight="normal" color="blue.800">
            <FormattedMessage defaultMessage="share" id="lRcBEU" />
          </Text>

          <FacebookIcon round={true} size={22} />
        </SimpleGrid>
      </FacebookShareButton>

      <TwitterShareButton url={getCurrentUrl() || `/products/${product.slug}`}>
        <SimpleGrid alignItems="center" gridAutoFlow="column" gridColumnGap={2} p={1}>
          <Text fontSize="sm" fontWeight="normal" color="blue.500">
            tweet
          </Text>

          <TwitterIcon round={true} size={22} />
        </SimpleGrid>
      </TwitterShareButton>

      {onToggleBookmark && (
        <Button
          aria-label={
            product.viewerDidBookmark
              ? intl.formatMessage({ defaultMessage: 'remove bookmark', id: 'ucGBsJ' })
              : intl.formatMessage({ defaultMessage: 'bookmark', id: 'xYk4VA' })
          }
          variantColor="teal"
          size="sm"
          variant="outline"
          onClick={() => onToggleBookmark(product)}
          rightIcon={props => {
            if (product.viewerDidBookmark) {
              return (
                <svg width={13} height={20} viewBox="0 0 14 20" fill="none" {...props}>
                  <path
                    d="M2.691 1.726c-.679 0-1.191.53-1.191 1.13v14.929l5.074-4.914 5.073 4.915V2.856c0-.6-.513-1.13-1.191-1.13H2.69zM0 2.856C0 1.382 1.23.226 2.691.226h7.765c1.461 0 2.691 1.157 2.691 2.63v15.792c0 .644-.532 1.126-1.138 1.126h-.001c-.293 0-.578-.113-.793-.319l-.003-.002-4.638-4.493-4.637 4.49-.001.001c-.327.318-.81.407-1.226.24A1.125 1.125 0 010 18.647V2.856z"
                    fill="#28D094"
                  />
                  <path
                    d="M1.5 2.856c0-.6.512-1.13 1.191-1.13h7.765c.678 0 1.191.53 1.191 1.13v14.93L6.574 12.87 1.5 17.785V2.856z"
                    fill="#28D094"
                  />
                </svg>
              );
            }

            return (
              <svg width={13} height={20} viewBox="0 0 13 20" xmlns="http://www.w3.org/2000/svg" {...props}>
                <path
                  d="M2.9445 2.05874C2.30562 2.05874 1.82339 2.55742 1.82339 3.12222V17.1728L6.59853 12.5483L11.3736 17.1735V3.12222C11.3736 2.55795 10.8912 2.05874 10.2525 2.05874H2.9445ZM0.411621 3.12222C0.411621 1.73505 1.5693 0.646973 2.9445 0.646973H10.2525C11.6279 0.646973 12.7854 1.73594 12.7854 3.12222V17.9849C12.7854 18.5913 12.2842 19.0446 11.7141 19.0446H11.713C11.4375 19.0442 11.1689 18.9388 10.9666 18.7447L10.9643 18.7424L6.59845 14.5137L2.23437 18.7401C2.2341 18.7404 2.23383 18.7406 2.23355 18.7409C1.92612 19.04 1.47166 19.1241 1.08007 18.9661C0.685916 18.8083 0.411499 18.4267 0.411621 17.9848V3.12222Z"
                  fill="currentColor"
                />
              </svg>
            );
          }}
        >
          {product.viewerDidBookmark ? (
            <FormattedMessage defaultMessage="saved" id="dxFzER" />
          ) : (
            <FormattedMessage defaultMessage="save" id="EjXcOc" />
          )}
        </Button>
      )}
    </SimpleGrid>
  );
}

function getCurrentUrl() {
  if (typeof window === "undefined") {
    return "";
  }

  return window.location.href;
}
